import { render } from "./App.vue?vue&type=template&id=3d8e74c4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3d8e74c4&lang=scss"

import exportComponent from "D:\\code\\chikii-web\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.47+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__